import { Box, Theme } from "@outschool/backpack";
import { TFunction } from "@outschool/localization";
import { searchPath } from "@outschool/routes";
import { useSession } from "@outschool/ui-auth";
import { useNavigation } from "@outschool/ui-utils";
import React from "react";
import { useLocation } from "react-router-dom";

import useExperiment from "../../hooks/useExperiment";
import { SearchFiltersContextProvider } from "../../lib/useSearchFilters";
import DesktopSearchField from "../search/desktop/DesktopSearchField";

function useGlobalSearchTeachersExperiment() {
  const { isLoggedIn } = useSession();
  const { variant, trigger } = useExperiment("GlobalSearchTeachers");
  const isTreatment = isLoggedIn && variant === "treatment";
  return {
    isTreatment,
    trigger
  };
}

export default function GlobalSearchBar({ t }: { t: TFunction }) {
  const nav = useNavigation();
  const location = useLocation();
  const shouldHide = ["/search", "/tutoring"].includes(location.pathname);
  const { isTreatment, trigger } = useGlobalSearchTeachersExperiment();

  if (shouldHide) {
    return null;
  }

  return (
    <Box
      sx={(theme: Theme) => ({
        width: "100%",
        [theme.breakpoints.down("md")]: {
          display: "none"
        }
      })}
    >
      <SearchFiltersContextProvider>
        <DesktopSearchField
          searchFilters={{}}
          setImplicitSearchFilters={() => {}}
          setSearchFilters={filters => {
            nav(searchPath(filters));
          }}
          clearDropdowns={() => {}}
          /* eslint-disable i18next/no-literal-string */
          searchSuggestionsToIgnore={isTreatment ? [] : ["teachers"]}
          experimentTrigger={trigger}
          useGlobalNavUi
          searchPlaceholder={t("Search online classes and tutors")}
        />
      </SearchFiltersContextProvider>
    </Box>
  );
}
